import {Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CalendarProperty, PaginateEnum} from '../../chartBlocks/ChartVO';
import {visavailChart} from '../../chartBlocks/chartBlocks';
import {DialogComponent} from '../../../view/dialog/dialog.component';
import * as moment from 'moment';
import {Legends} from '../../../model/Legends';
import {MatHorizontalStepper} from '@angular/material';
import {ApiService} from '../api.service';
import {DrawerDetails, RequestBodyVacations, ValidationVacation} from '../InjectionVO';
import {DATA_BLOCKS, MOTIFS} from '../exports';
import {AuthService} from '../../../auth/services/auth.service';

@Component({
    selector: 'app-history-details',
    templateUrl: './history-details.component.html',
    styleUrls: ['./history-details.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class HistoryDetailsComponent implements OnInit {
    @ViewChild('stepper') stepper: MatHorizontalStepper;
    data: any;
    _sizeElement: number;
    _send: boolean = false;
    _sendErrorAlreadyExist: boolean = false;
    _sendError: boolean = false;
    _failedItem: RequestBodyVacations;

    @Input() set sizeElement(v: number) {
        this._sizeElement = v;
        // timeout set index stepper after hide drawer
        setTimeout(() => {
            if (v == 0) {
                this.stepper.selectedIndex = 0;
            }
        }, 5e2);
    };

    @Input() totalElement: number;
    @Input() dataSource: ValidationVacation;


    /* Output Event */
    @Output() event: EventEmitter<DrawerDetails<any>> = new EventEmitter<DrawerDetails<any>>();
    isTotallyOverlapped = 0;

    get sizeElement() {
        return this._sizeElement;
    }

    public blocksViewer: Array<any> = [{}];
    public motifs: Array<any> = MOTIFS;

    constructor(private inj: Injector, private translate: TranslateService, private api: ApiService, private authService: AuthService) {
        console.log('inj::', inj);
    }

    addV() {
        this.blocksViewer.push(null);
    }

    ngOnInit() {
        setTimeout(() => {
            //this.initChart('.xx');sizeElement
        }, 1e3);
        this.stepper.selectionChange.subscribe(() => {
            this._send = false;
            this._sendError = false;
        });
    }

    reasonStep(reason: string) {
        this.dataSource.decision = reason;
        if (reason == 'REJECTED') {
            this.stepper.next();
            this.send();
        } else if (reason == 'APPROVED') {
            this.isTotallyOverlapped = this.isTotallyOrPartialOverlapped();
            if (this.isTotallyOverlapped == 2 || this.isTotallyOverlapped == 1) {
                this._sendErrorAlreadyExist = true;
            }
        }
        this.stepper.next();
    }

    send() {
        this._send = true;
        this._sendError = false;

        this.api.validationVacation(this.dataSource).then((data: any) => {
            const {failedItems} = data || {failedItems: []};
            const failedItem = failedItems.find((e: RequestBodyVacations) => e.failedReasons.length > 0);
            this._send = false;
            if (failedItem) {
                this._sendError = true;
                this._failedItem = failedItem;
                this._sendErrorAlreadyExist = false;
            } else {
                setTimeout(() => {
                    this.authService.countInjectionPending();
                    this.stepper.next();
                }, 2e3);
            }
        }).catch((err) => {
            this._send = false;
            this._sendError = true;
            this._sendErrorAlreadyExist = false;
//      this.notification.show()
        });


    }

    initChart(selector) {
        this.data = DATA_BLOCKS;

        const xx = visavailChart({
            selector,
            initialView: 'FULL',
            timeZone: 1,
            translations: {
                lang: this.translate.currentLang,
                translate: this.translate.translations[this.translate.currentLang]
            },
            data: {
                temps_data: [],
                dataset: [{
                    'caption': 'Prévu',
                    'data': [],
                    'disp_data': []
                },
                    {
                        'caption': 'Réalise',
                        'data': this.data.blockVOS.filter(e => e.blockStatus == 'PROCESSED').map((e: any) => {
                            const end = e.hasOwnProperty('end') ? new Date(e.end) : new Date();
                            return [new Date(e.start), `ACTION_${e.activityType}`.toUpperCase(), end, 1, e.source];
                            //return [new Date(e.start), `${e.label}_${e.activityType}`.toUpperCase(), end , 1, e.source]
                        }),
                        'disp_data': []
                    }],
                user: {
                    username: '047780',
                    firstname: '047780',
                    lastname: '047780',
                    date: ''
                },
                Display: {
                    'breaks': true,
                    'header': true,
                    'paginator': true,
                    'buttons': {
                        'valider': true,
                        'claim': false
                    },
                    'styles': {
                        'margin': {
                            'top': 70,
                            'right': 40,
                            'bottom': 20,
                            'left': 100
                        },
                        'height': '235px',
                        'width': 940
                    },
                    'dialog': true
                },
            },
            calendar: {
                date: '',
                maxDate: '',
                minDate: '',
                paginator: true
            },
            on: {
                isValidated: () => {
                    return true;
                },
                calendar: {
                    pickCalendar: (calendar: CalendarProperty) => {
                        if (calendar.paginator) {
                            //this.picker.panelClass = 'calendar-block';
                            //this.picker.open();
                        }
                    },
                    paginate: (step: PaginateEnum) => {
                        //thiscomponent.GoToDate(step, null);
                    }
                },
                isNow: () => {
                    return true;
                },
                block: {
                    click: () => {
                    },
                    hover: (d: any) => {
                        const translate = this.translate.translations[this.translate.currentLang];
                        let Tmotif, motif, label, justif, motifGlobalCode, klass = '';
                        klass = (Legends[d[1]] || '').class;
                        const block: any = this.data.blockVOS.find((t: any) => {
                            const same = moment(t.start, 'YYYY-MM-DD HH:mm:ss')
                                .isSame(moment(d[0], 'YYYY-MM-DD HH:mm:ss'));
                            const isLabel = `${t.label}_${t.activityType}`.toUpperCase() === d[1];
                            return same;
                        });

                        if (block && block.motif) {

                            motif = (block.motif && block.motif.label === '' ? '' : ' : ' + translate.MOTIFS[block.motif.code]);
                            label = (block.motif && block.motif.label === '' ? 'INSERVICE' : label);
                            justif = block.justification;
                            motifGlobalCode = Tmotif = block.motif.code;
                        }

                        return {
                            template: `<table class="${klass}" style="top: 25px !important;position: relative;">
                            <tr>
                              <th>${translate.BLOCK_TEMPS.TOOLTIP.STATUS}</th>
                              <th>${translate.BLOCK_TEMPS.TOOLTIP.STATUS}</th>
                            </tr>

                            <tr>
                              <td>${motif}</td>
                              <td>${block.start}</td>
                            </tr>

                          </table>`
                        };
                    },
                    MOTIFS: []
                }
            },
            message: {
                icon: '', title: '', body: [
                    '<div>🇫🇷 : Collecte en cours, le traitement des incohérences de cette journée sera accessible dès que possible</div>',
                    '<div>🇺🇸 : Collection in progress, the treatment of the inconsistencies of this day will be accessible as soon as possible</div>',
                    '<div>🇪🇸 : Cobro en curso, el tratamiento de las inconsistencias de este día será accesible a la mayor brevedad</div>',
                    '<div>🇵🇹 : Cobrança em andamento, o tratamento das inconsistências deste dia estará acessível o mais breve possível</div>',
                ], show: false
            }
        })
            .dialog(DialogComponent)
            .callback(null)
            .render();


        /*    d3.select(".xx")
              .datum([
                {
                  "caption": "Prévu",
                  "data": [],
                  "disp_data": []
                },
                {
                  "caption": "Réalisé",
                  "data": [],
                  "disp_data": []
                },
                {
                  "caption": "Réalisé Validée",
                  "data": [],
                  "disp_data": []
                }
              ])
              .call(xx);*/
    }


    onEvent(event) {
        this.event.emit({
            event,
            data: {}
        });
        this._sendErrorAlreadyExist = false;
    }

    private isTotallyOrPartialOverlapped() {

        let isTotally = this.dataSource.injectionParamVos.filter(injection => injection.etat == 2).length > 0;
        let isPartial = this.dataSource.injectionParamVos.filter(injection => injection.etat == 1).length > 0;
        if (isTotally) {
            return 2;
        }
        if (isPartial) {
            return 1;
        }

        return 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/injection/history-details/history-details.component.ts